export default __webpack_public_path__ + "static/media/100000points.a2a3e71c.png";